import { gql } from '@apollo/client';
import USER_FRAGMENT from './userFragment.graphql';

const GET_USERS_ASSIGNABLE_TO_PROJECT_QUERY = gql`
  query GetUsersAssignableToProject(
    $projectId: ID!
    $query: String
    $first: Int
    $after: String
  ) {
    viewer {
      __typename
      id
      usersAssignableToProject(
        projectId: $projectId
        query: $query
        first: $first
        after: $after
      ) {
        pageInfo {
          hasNextPage
          endCursor
        }
        nodes {
          ...ProjectUserFragment
        }
      }
    }
  }
  ${USER_FRAGMENT}
`;

export default GET_USERS_ASSIGNABLE_TO_PROJECT_QUERY;
